export const publicWebAplicationUrl = process.env.REACT_APP_WEB_PUBLIC;
export const adminWebUserPortalAplicationUrl =
  process.env.REACT_APP_WEB_USER_PORTAL_ADMIN;

export const homeRoute = "/";
export const aboutProgramRoute = "/aboutprogram";
export const izjavaOPristupacnostiRoute = "/izjava-o-pristupacnosti";

export const criteriaRoute = `/criteria`;
export const newCriterionRoute = `/criteria/new`;
export const editCriterionRoute = `/criteria/:id/edit`;
export const editCriterionUrl = (id: number) => `${criteriaRoute}/${id}/edit`;

export const capacitiesRoute = "/capacities";
export const newCapacityRoute = `/capacities/new`;
export const editCapacityRoute = `/capacities/:id/edit`;
export const editCapacityUrl = (id: number) => `${capacitiesRoute}/${id}/edit`;

export const subsequentCapacitiesRoute = "/subsequent-capacities";
export const newSubsequentCapacityRoute = `/subsequent-capacities/new`;
export const editSubsequentCapacityRoute = `/subsequent-capacities/:id/edit`;
export const editSubsequentCapacityUrl = (id: number) =>
  `${subsequentCapacitiesRoute}/${id}/edit`;

export const benfitsRoute = `/benefits`;
export const newBenefitRoute = `/benefits/new`;
export const detailsBenefitRoute = `/benefits/:id/details`;
export const detailsBenefitUrl = (id: number) =>
  `${benfitsRoute}/${id}/details`;

export const requestsRoute = "/requests";
export const requestDetailsRoute = "/requests/:requestId";
export const requestBasicInfoUrl = (requestId: number): string =>
  `/requests/${requestId}/basic-info`;

export const subsequentRequestsRoute = "/subsequentRequests";
export const subsequentRequestDetailsRoute = "/subsequentRequests/:requestId";
export const subsequentRequestBasicInfoUrl = (requestId: number): string =>
  `/subsequentRequests/${requestId}/basic-info`;

export const requestDraftDetailUrl = (
  guid: string,
  applicantParentOib: string
): string =>
  `${publicWebAplicationUrl}/requests/drafts/${guid}/details?applicantParentOib=${applicantParentOib}`;

export const newRequestUrl = (
  applicantParentOib: string,
  childOib: string,
  isCustodyConfirmed: boolean
): string =>
  `${publicWebAplicationUrl}/requests/new?applicantParentOib=${applicantParentOib}&childOib=${childOib}&IsCustodyConfirmed=${isCustodyConfirmed}`;

export const editRequestUrl = (
  requestId: number,
  applicantParentOib: string
): string =>
  `${publicWebAplicationUrl}/requests/${requestId}/edit?applicantParentOib=${applicantParentOib}`;

export const enrollmentListRoute = "/enrollmentList";
export const confirmedEnrollmentListRoute = "/confirmedEnrollmentList";
export const rejectedEnrollmentListRoute = "/rejectedEnrollmentList";

export const importantDateListRoute = `/important-date`;
export const editImportantDateRoute = `/important-date/:id/edit`;
export const beneficiaryListRoute = `/beneficiary`;
export const editImportantDateUrl = (id: number) =>
  `/important-date/${id}/edit`;

export const subsequentImportantDateListRoute = `/subsequent-important-date`;
export const editSubsequentImportantDateRoute = `/subsequent-important-date/year/:id/month/:monthId/edit`;
export const editSubsequentImportantDateUrl = (id: number, monthId: number) =>
  `/subsequent-important-date/year/${id}/month/${monthId}/edit`;

export const preschoolRequestsRoute = "/preschoolRequests";
export const preschoolRequestDetailsRoute = "/preschoolRequests/:requestId";
export const preschoolRequestBasicInfoUrl = (requestId: number): string =>
  `/preschoolRequests/${requestId}/basic-info`;

export const preschoolRequestDraftDetailUrl = (
  guid: string,
  applicantParentOib: string
): string =>
  `${publicWebAplicationUrl}/preschoolRequests/drafts/${guid}/details?applicantParentOib=${applicantParentOib}`;

export const newPreschoolRequestUrl = (
  applicantParentOib: string,
  childOib: string,
  isCustodyConfirmed: boolean
): string =>
  `${publicWebAplicationUrl}/preschoolRequests/new?applicantParentOib=${applicantParentOib}&childOib=${childOib}&isCustodyConfirmed=${isCustodyConfirmed}`;

export const editPreschoolRequestUrl = (
  requestId: number,
  applicantParentOib: string
): string =>
  `${publicWebAplicationUrl}/preschoolRequests/${requestId}/edit?applicantParentOib=${applicantParentOib}`;

export const preschoolEnrollmentListRoute = "/preschoolEnrollmentList";
export const preschoolConfirmedEnrollmentListRoute =
  "/preschoolConfirmedEnrollmentList";
export const preschoolRejectedEnrollmentListRoute =
  "/preschoolRejectedEnrollmentList";

export const subsequentEnrollmentListRoute = "/subsequentEnrollmentList";
export const subsequentConfirmedEnrollmentListRoute =
  "/subsequentConfirmedEnrollmentList";
export const subsequentRejectedEnrollmentListRoute =
  "/subsequentRejectedEnrollmentList";

export const newErrorReportUrl = (
  id: string | undefined,
  message: string,
  date: Date,
  url: string
): string =>
  `/errorReport/new?id=${id}&message=${message}&date=${date}&url=${url}`;

export const newErrorReporRoute = "/errorReport/new";

export const initialConversationRoute = "/initialConversation";